'use client'

/**
 * Color Theme Handler
 *
 * 네이티브에서 전달되는 색상 정보를 받아서
 * CSS 변수로 설정하여 전역 스타일에 적용하는 컴포넌트
 */

import { useQuery } from '@tanstack/react-query'
import { useEffect } from 'react'

import { appQueryOptions } from '@/api/bridge/app'

export default function ColorThemeHandler() {
  // 클라이언트 사이드에서만 실행되도록 enabled 조건 추가
  const { data } = useQuery({
    ...appQueryOptions.getColor(),
    enabled: typeof window !== 'undefined'
  })

  useEffect(() => {
    // 클라이언트 사이드에서만 실행
    if (typeof window === 'undefined' || !data) {
      return
    }

    const { primaryColor, primaryColorVariant, onPrimaryColor } = data

    // CSS 변수 설정
    const root = document.documentElement

    if (primaryColor) {
      root.style.setProperty('--adison-primary', primaryColor)
    }

    if (primaryColorVariant) {
      root.style.setProperty('--adison-primary-strong', primaryColorVariant)
    }

    if (onPrimaryColor) {
      root.style.setProperty('--adison-on-primary', onPrimaryColor)
    }
  }, [data])

  return null
}
